import _functionCall from "../internals/function-call";
import _hasOwnProperty from "../internals/has-own-property";
import _objectIsPrototypeOf from "../internals/object-is-prototype-of";
import _regexpFlags from "../internals/regexp-flags";
var exports = {};
var call = _functionCall;
var hasOwn = _hasOwnProperty;
var isPrototypeOf = _objectIsPrototypeOf;
var regExpFlags = _regexpFlags;
var RegExpPrototype = RegExp.prototype;
exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !("flags" in RegExpPrototype) && !hasOwn(R, "flags") && isPrototypeOf(RegExpPrototype, R) ? call(regExpFlags, R) : flags;
};
export default exports;